import useTheme from '@material-ui/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const useIsDesktopNav = () => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: false,
    noSsr: true,
  })
}

export default useIsDesktopNav
